const schoolContext =
  typeof window !== 'undefined' ? (window as any).school_context : undefined

export const context = schoolContext == 'dar_albayan' ? 'bayen_school' : 'manarah_school'
